import type { BindFeature } from '@wix/thunderbolt-catharsis-ioc'
import { CssFeatureSymbol } from '../../ioc/catharsis-ioc'
import { CursorCssFeature } from './cursor.types'
import { cursor } from './cursorCompNode'
import { cursorDomApplier } from './cursorDomApplier'
import { cursorVariants } from './cursorVariantsCompNode'

export const cursorCssFeature: CursorCssFeature = {
	featureName: 'cursor',
	experimentName: 'OPEN_TO_ALL',
	renderableNodes: { cursor, cursorVariants },
	intermediateNodes: {},
	dataMaps: ['cursor'],
	domApplier: cursorDomApplier,
}

export const page: BindFeature = (bind) => {
	bind(CssFeatureSymbol).toConstantValue(cursorCssFeature)
}
export const editor: BindFeature = page
